<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{ caption }}<strong v-if="required" class="required">*</strong>
        </template>
        <template #input>
            <div class="input-row">
                <input :class="{ 'input-component': true, 'active': active}" v-model="internalValue"
                       @blur="compute" @focus="toggleActive" :disabled="disabled" @keydown.enter="compute"/>

                <input class="input-preview" style="margin-left: 10px" v-model="previewValue"
                       @blur="compute" @focus="toggleActive" disabled @keydown.enter="compute"/>

            </div>
        </template>
    </form-input-layout>
</template>

<script>
import FormInputLayout from "./FormInputLayout";
import { evaluate } from 'mathjs'
import { prepareExpression } from "@/utils/number-input";
import { mapGetters } from "vuex";

export default {
    name: "FormDecimalInput",
    components: {FormInputLayout},
    props: {
        value: Number,
        disabled: Boolean,
        caption: String,
        required: Boolean,
        helpItemCode: String,
        precision: Number
    },
    data() {
        return {
            active: false,
            internalValue: "0"
        }
    },
    computed: {
        ...mapGetters({
            "getPreference": "userPreferences/getPreference"
        }),

        decimalSeparator() {
            return this.getPreference('defaultNumberSeparator');
        },
        thousandSeparator() {
            return this.getPreference('defaultThousandSeparator');
        },

        outputFormat() {
            return `0,0.${'0'.repeat(this.precision)}`;
        },

        expression() {
            return prepareExpression(this.internalValue).replaceAll(this.thousandSeparator, '').replaceAll(this.decimalSeparator, '.');
        },

        previewValue() {
            if (this.active) {
                try {
                    return this.$numeral(evaluate(this.expression)).format(this.outputFormat);
                } catch (e) {
                    return this.$t('notValidInput');
                }
            } else {
                return ''
            }
        }
    },

    methods: {
        toggleActive() {
            this.active = !this.active;
        },

        compute() {

            try {
                const result = evaluate(this.expression);
                this.$emit('input', result * Math.pow(10, this.precision));
            } catch (e) {
                this.internalValue = '';
                console.log('ERROR', e)
            }

            this.toggleActive();
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.internalValue = this.$numeral((newVal !== undefined ? newVal : 0) / Math.pow(10, this.precision)).format(this.outputFormat);
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.input-component {
    border: none;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    border-radius: 5px;
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}

.input-row {
    display: flex;
}

.input-preview {
    border: none;
    background-color: transparent;
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
}

</style>